import Vue from 'vue'
import App from './App.vue'
import router from './routers'
import store from './store'
import './assets/style/base.less'
import './core/vant-use'
// import vconsole from 'vconsole'
// new vconsole()
import '@/plugins'
import './configs/config'



Vue.config.productionTip = false
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
